'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M240 0l80 0 0 192 64 0 0 32-160 0 0-32 64 0 0-160-64 0 0-32 16 0zM16 288l80 0 0 192 64 0 0 32-160 0 0-32 64 0 0-160-64 0 0-32 16 0zM0 0L192 0 192 224 0 224 0 0zM32 32l0 160 128 0 0-160-128 0zM208 288l176 0 0 224-192 0 0-224 16 0zm16 192l128 0 0-160-128 0 0 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;